import { StoreId } from "./storeLinks";

// Apple has no Ukrainian badge; its uk-ua file is the English fallback Apple ships.
const APPLE_BADGE_LOCALES: Record<string, string> = {
  en: "en-us",
  de: "de-de",
  ja: "ja-jp",
  uk: "uk-ua",
  pl: "pl-pl",
};
const GOOGLE_BADGE_LOCALES = new Set(["en", "de", "ja", "uk", "pl"]);

/**
 * The official badge for the language on screen, falling back to English. Apple's black badge is
 * used in light and dark mode alike, as Apple's guidelines allow.
 */
export function badgeSrc(store: StoreId, language: string): string {
  const base = language.slice(0, 2).toLowerCase();
  if (store === "app-store") return `/badges/apple-black-${APPLE_BADGE_LOCALES[base] ?? "en-us"}.svg`;
  return `/badges/google-${GOOGLE_BADGE_LOCALES.has(base) ? base : "en"}.png`;
}
